<!--L’action restante étant présélectionnée à chaque ouverture (SU #118470), validerDesactive n’est
    plus jamais vrai. La liaison est conservée : elle redevient utile dès qu’une seconde action est
    remise dans la liste.-->
<val-boite-dialogue-generique #boiteDialogue
                              [titre]="titre | transloco"
                              class="val-refuser-factures-achat"
                              [validerDesactive]="actionSelectionnee === null"
                              (validerClick)="Valider ()"
                              (annulerClick)="Annuler ()">
  <div contenu class="val-refuser-factures-achat-contenu">
    <val-simple-panel>
      <val-controle-conteneur [label]="'achat.commun.action' | transloco"
                              [tailleLabel]="tailleLabels">
        <kendo-combobox class="val-kd-combobox"
                        size="small"
                        [clearButton]="false"
                        [popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
                        [data]="actions"
                        textField="libelle"
                        valueField="refuser"
                        [(value)]="actionSelectionnee">
        </kendo-combobox>
      </val-controle-conteneur>
      <div style="height: 4px;"></div>
      <div class="val-refuser-factures-achat-selection">
        {{ 'achat.commun.factures-selectionnees' | transloco: { nombre: nombreFacturesSelectionnees } }}
      </div>
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
